import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { LoginPage } from '@/auth/LoginPage'
import { NoAccount } from '@/auth/NoAccount'
import { RequireAuth, Splash } from '@/auth/SessionProvider'
import { SetupIncomplete } from '@/auth/SetupIncomplete'
import { PropertyPage } from '@/sections/empire/PropertyPage'
import { AppShell } from '@/shell/AppShell'

// The map pulls in mapbox-gl (~1.7 MB): load it only once someone is signed in.
const MapPage = lazy(() => import('@/map/MapPage').then((m) => ({ default: m.MapPage })))

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/no-account" element={<NoAccount />} />
      <Route path="/setup-incomplete" element={<SetupIncomplete />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route
          path="/map"
          element={
            <Suspense fallback={<Splash />}>
              <MapPage />
            </Suspense>
          }
        />
        <Route path="/empire" element={<Navigate to="/empire/property" replace />} />
        <Route path="/empire/property" element={<PropertyPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/map" replace />} />
    </Routes>
  )
}
